import React, { useEffect, useState } from "react";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import AmountInput from "./AmountInput";
import useInitiatePayment from "./apicall";
import LoadingState from "./LoadingState";
import FailedStateCard from "../../TxnFailedState";
import { posValidation } from "../../../validations/paymentModeValidation";
import Error from "../../../errorHandlimg/Error";
import AvailablePosDropdown from "./AvailablePosDropdown";
import Item from "antd/lib/list/Item";
const PineLapUI = ({ heading, contextValue, isView = false }) => {
  const [errorMsg, setErrorMsg] = useState("");
  const [vendorType, setVendorType] = useState("");
 
  const {
    setBalanceMode,
    setBalanceAmount,
    setCollectPayment,
    currentPaymentMode,
    bankMasterId,
    balanceAmount,
    availablePosList,
  } = contextValue;
  const [amount, setAmount] = useState("");

  const posDropdown =
  availablePosList &&
  availablePosList
  .filter(item=>!(item?.feature?.toLowerCase().includes("axis")))
  .map((item) => ({
    label: item?.feature,
    value: item?.feature,
  }));


  const { initiatePayment, responseData, loader, setResponse } =
    useInitiatePayment(
      setBalanceAmount,
      setBalanceMode,
      setCollectPayment,
      currentPaymentMode,
      bankMasterId
    );

  useEffect(() => {
    if (posDropdown && posDropdown?.length === 1) setVendorType(posDropdown[0]);
  }, [availablePosList]);

  const inputHandler = (value) => {
    setAmount(value);
  };
  const vendorTypeHandler = (e) => {
    setVendorType(e);
  };
  const startPayment = () => {
    if (amount > 0) {
      const error = posValidation(amount, balanceAmount);
      if (error) {
        setErrorMsg(error);
        return;
      }
      initiatePayment(
        contextValue?.studentBasicDetails,
        amount,
        vendorType,
        contextValue?.state,
        contextValue?.setState
      );
      setErrorMsg("");
    }
  };

  if (responseData && responseData?.data?.status === "FAILED")
    return <FailedStateCard retryHandler={() => setResponse({})} />;

  if (loader)
    return (
      <div>
        <LoadingState isLoading={true} />
      </div>
    );

  return (
    <>
      {!isView && (
        <div className=" d-flex justify-content-between align-items-center mt-2">
          <span className="large-bold color-dark">{heading}</span>
        </div>
      )}
      <div className="d-flex mt-1 gap-md">
        <AvailablePosDropdown
          value={vendorType}
          onChangeHandler={vendorTypeHandler}
          posDropdown = {posDropdown}
          isDisable ={posDropdown?.length === 1}
        />
        <AmountInput
          label="Enter Amount"
          value={amount}
          onChange={(value) => inputHandler(value)}
          disabled={false}
          maxLimit={10000} // example max limit
        />
      </div>
      <div className="mt-3" style={{ marginLeft: "-12px" }}>
        <AButton
          disabled={!amount || vendorType === ""}
          variant={"primary_filled"}
          onClick={startPayment}
        >
          Start POS
        </AButton>
      </div>
      <Error errorMgs={errorMsg} />
    </>
  );
};
export default PineLapUI;
